import { render, staticRenderFns } from "./SettlementRecord.vue?vue&type=template&id=61bab982&"
import script from "./SettlementRecord.vue?vue&type=script&lang=js&"
export * from "./SettlementRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports